// Canonical production domain used for SEO metadata (canonical URLs, sitemap, Open Graph).
export const SITE_URL = "https://btcarcade.us";
export const SITE_NAME = "InnerArcade";
export const SITE_TAGLINE = "Play with purpose";
export const OG_DEFAULT = `${SITE_URL}/og-default.jpg`;
